import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState, useEffect } from 'preact/hooks';
import { injectMacrosText } from '../utils';
import { useIsMobile } from '../utils/responsive';
export function OfferHeader({ settings, styles, userAttributes, onClose, }) {
    const [showCloseButton, setShowCloseButton] = useState(false);
    useEffect(() => {
        if (!settings.enable_close_delay || !settings.close_delay) {
            setShowCloseButton(true);
            return;
        }
        const timer = setTimeout(() => {
            setShowCloseButton(true);
        }, settings.close_delay * 1000);
        return () => clearTimeout(timer);
    }, [settings.enable_close_delay, settings.close_delay]);
    if (settings.embedded?.showHeader === false) {
        return null;
    }
    const headerStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: useIsMobile() ? '10px 24px' : '6px 24px',
        backgroundColor: styles.header?.background || 'rgb(11, 25, 55)',
        color: styles.header?.textColor || 'white',
        fontFamily: styles.header?.font || styles.offerText?.font || 'Roboto, sans-serif',
        fontSize: `${styles.header?.fontSize || 16}px`,
    };
    const titleStyles = {
        margin: 0,
        fontSize: `${styles.header?.fontSize || 16}px`,
        fontWeight: '500',
        color: styles.header?.textColor || 'white',
        flex: 1,
        maxWidth: '95%',
        display: '-webkit-box',
        WebkitLineClamp: 4,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    };
    const closeButtonStyles = {
        background: 'transparent',
        border: 'none',
        color: styles.header?.textColor || 'white',
        fontSize: '24px',
        cursor: 'pointer',
        padding: '0px',
        transition: 'background-color 0.2s ease',
        opacity: showCloseButton ? 1 : 0.3,
        pointerEvents: showCloseButton ? 'auto' : 'none',
    };
    const closeButtonHoverStyles = {
    // backgroundColor: 'rgba(255, 255, 255, 0.1)',
    };
    return (_jsxs("div", { id: 'adpx_modal-header', className: 'adpx_modal-header', style: headerStyles, children: [_jsx("h2", { id: 'adpx_modal-title', className: 'adpx_modal-title', style: titleStyles, children: injectMacrosText(styles.header?.text || 'Check these Offers from brands you may love!', userAttributes) }), settings.show_close && !settings.embedded?.enabled && (_jsx("button", { id: 'adpx_close-button', className: 'adpx_close-button', style: closeButtonStyles, onClick: onClose, disabled: !showCloseButton, onMouseEnter: e => {
                    if (showCloseButton) {
                        Object.assign(e.currentTarget.style, closeButtonHoverStyles);
                    }
                }, onMouseLeave: e => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                }, "aria-label": 'Close', children: "\u00D7" }))] }));
}
